import React from 'react';
import { Icon } from '@iconify/react';

const FlowNode = ({ icon, label, color, className }) => (
    <div className={`bg-white px-2 py-1.5 rounded-lg shadow-md border border-gray-100 flex items-center gap-1.5 min-w-[80px] z-10 ${className}`}>
        <div className={`w-4 h-4 rounded-full flex items-center justify-center ${color}`}>
            {icon}
        </div>
        <span className="text-[8px] font-bold text-gray-700">{label}</span>
    </div>
);

export const LayerEditingVisual = () => {
  return (
    <div className="relative w-full h-full flex items-center justify-center">

        {/* Connection Lines SVG */}
        <svg className="absolute inset-0 w-full h-full pointer-events-none z-0">
             {/* Start to Decision */}
             <path d="M100 50 L 100 70 L 140 70 L 140 90" stroke="#E5E7EB" strokeWidth="2" fill="none" strokeDasharray="3 3" />
             {/* Decision to Left */}
             <path d="M140 120 L 140 130 L 90 130 L 90 150" stroke="#E5E7EB" strokeWidth="2" fill="none" />
             {/* Decision to Right */}
             <path d="M140 120 L 140 130 L 190 130 L 190 150" stroke="#E5E7EB" strokeWidth="2" fill="none" />
        </svg>

        {/* Workflow Nodes */}
        <div className="absolute top-6 left-16">
            <FlowNode
                icon={<Icon icon="mdi:flash" width={8} className="text-yellow-600" />}
                label="Trigger: New Comment"
                color="bg-yellow-100"
            />
        </div>

        <div className="absolute top-24 left-1/2 transform -translate-x-1/2">
             <div className="bg-white px-3 py-1 rounded-full shadow-sm border border-purple-200 text-[8px] text-purple-600 font-bold z-10 relative">
                Sentiment Analysis?
             </div>
        </div>

        <div className="absolute bottom-10 left-8">
            <FlowNode
                icon={<Icon icon="mdi:thumb-up" width={8} className="text-green-600" />}
                label="Positive: Auto-Like"
                color="bg-green-100"
            />
        </div>

        <div className="absolute bottom-10 right-8">
            <FlowNode
                icon={<Icon icon="mdi:bell" width={8} className="text-blue-600" />}
                label="Question: Notify Team"
                color="bg-blue-100"
            />
        </div>

        {/* Control Panel */}
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur rounded-lg shadow-sm border border-gray-100 p-2 flex flex-col gap-2">
            <div className="flex items-center justify-between gap-3">
                <span className="text-[8px] font-medium text-gray-500">Auto-Reply</span>
                <div className="w-6 h-3 bg-purple-500 rounded-full relative">
                    <div className="absolute right-0.5 top-0.5 w-2 h-2 bg-white rounded-full"></div>
                </div>
            </div>
            <div className="flex items-center justify-between gap-3 opacity-50">
                <span className="text-[8px] font-medium text-gray-500">Weekend Mode</span>
                <div className="w-6 h-3 bg-gray-200 rounded-full relative">
                    <div className="absolute left-0.5 top-0.5 w-2 h-2 bg-white rounded-full"></div>
                </div>
            </div>
        </div>

    </div>
  );
};

export default LayerEditingVisual;
